"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const dynamic_1 = __importDefault(require("next/dynamic"));
const next12_components_custom_link_1 = __importDefault(require("@gcloud-npm/next12.components.custom-link"));
const next12_components_text_info_n_1 = __importDefault(require("@gcloud-npm/next12.components.text-info-n"));
const next12_components_icon_n_1 = __importDefault(require("@gcloud-npm/next12.components.icon-n"));
const react_redux_1 = require("react-redux");
const next12_app_controller_reducers_sagas_modals_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer");
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const ModalUser = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require("../modals/user"))));
class UserPill extends react_1.Component {
    constructor(props) {
        super(props);
        this.setDevice = () => {
            const device = (0, next12_utils_common_1.getDeviceKindDependsOnViewPort)();
            this.setState({ device });
        };
        this.openModal = () => {
            const { addModal, items, segmentMenu, options, userName, userType } = this.props;
            const { device } = this.state;
            const fadeIn = device === "mobile" ? "fadeInTop" : "fadeInTop";
            const fadeOut = device === "mobile" ? "fadeOutTop" : "fadeOutTop";
            addModal({
                id: "account",
                Element2Show: ModalUser,
                modalProps: {
                    contentPosition: "right--top",
                    opacityLayoutColor: "blur",
                    inSceneEffect: fadeIn,
                    contentInsideContainer: true,
                    outSceneEffect: fadeOut,
                    closeByClickingOutside: true,
                    onCloseHandler: this.onCloseHandler,
                },
                elementProps: {
                    items: Object.assign({}, items),
                    userName,
                    userType,
                },
            });
            this.setState({
                modalOpened: true,
            });
        };
        this.onCloseHandler = () => {
            const { modals, addModal } = this.props;
            if (modals.length > 0) {
                addModal({
                    id: "closeAll",
                });
            }
        };
        this.closeModal = () => {
            const { addModal } = this.props;
            addModal({
                id: "closeAll",
            });
            this.onCloseHandler();
        };
        this.state = {
            device: null,
        };
    }
    componentDidMount() {
        this.setDevice();
        window.addEventListener("resize", this.setDevice);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.setDevice);
    }
    render() {
        const { userName } = this.props;
        return (react_1.default.createElement("div", { className: "user-pill" },
            react_1.default.createElement(next12_components_custom_link_1.default, { onClick: this.openModal, title: "Mi cuenta", ariaLabel: "Mi cuenta", className: "button", taggingInfo: {
                    componentName: "header",
                    componentContent: "openAccount",
                    componentVariation: "all",
                    componentPerso: "",
                    componentProduct: "",
                } },
                react_1.default.createElement("div", { className: "user-icon" },
                    react_1.default.createElement(next12_components_icon_n_1.default, { id: "Usuario", color: "white", size: 20, kind: "M" }))),
            react_1.default.createElement("div", { className: "user-content" },
                react_1.default.createElement("div", { className: "user-name" }, userName),
                react_1.default.createElement("div", { className: "user-menu" },
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(next12_components_custom_link_1.default, { onClick: this.openModal, title: "Mi cuenta", ariaLabel: "Mi cuenta", taggingInfo: {
                                componentName: "header",
                                componentContent: "user-pill",
                                componentVariation: "all",
                                componentPerso: "",
                                componentProduct: "",
                            } },
                            react_1.default.createElement(next12_components_text_info_n_1.default, { text: "Mi cuenta", fontType: "font-regular", size: "caption03", color: "blue", display: "block" })))))));
    }
}
const mapStateToProps = (state) => ({
    modals: state.modals.modalHistory,
});
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next12_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(UserPill);
//# sourceMappingURL=index.js.map